module.exports = __webpack_public_path__ + "assets/icons/icon_signal5.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/svg/icon_signal5.svg
// module id = yZX0
// module chunks = 1